import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService} from 'angular2-notifications';
import {MimeTypeService} from '../../../app/shared/mime-type.service';

@Component({
  selector: 'app-gelios-image-field',
  templateUrl: './gelios-image-field.component.html',
  styleUrls: ['./gelios-image-field.component.scss']
})
export class GeliosImageFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  protected file: any;

  constructor(
    protected sanitizer: DomSanitizer,
    protected translateService: TranslateService,
    protected notif: NotificationsService,
    protected mimeTypeService: MimeTypeService,
  ) {
    super(translateService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  format() {
    return this.reflexiveField.imageFieldConfig && this.reflexiveField.imageFieldConfig.format ?
      this.reflexiveField.imageFieldConfig.format : 'image/png';
  }

  mimeType() {
    return this.mimeTypeService.getImageMimeType(this.formGroup.controls[this.fieldName].value);
  }

  imgSrc() {
    const mimeType = this.mimeType();
    return this.formGroup.controls[this.fieldName].value ?
      this.sanitizer.bypassSecurityTrustResourceUrl('data:' + mimeType + ';base64,' + this.formGroup.controls[this.fieldName].value) : '';
  }

  clearField() {
    this.formGroup.controls[this.fieldName].setValue(null);
    this.formGroup.controls[this.fieldName].setValue(this.formGroup.controls[this.fieldName].value);
  }

  fileInputChanged(e: any) {
    this.file = e.target.files[0];
    if (this.file) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        this.formGroup.controls[this.fieldName].setValue((fileReader.result as string).split(',')[1]);
        this.formGroup.controls[this.fieldName].setValue(this.formGroup.controls[this.fieldName].value);
        this.formGroup.controls[this.fieldName].markAsTouched({onlySelf: true});
        this.formGroup.controls[this.fieldName].updateValueAndValidity();
      };
      fileReader.readAsDataURL(this.file);
    }
  }
}
